var _path, _path2, _g, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAnalisis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_235_13315",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 7,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99704 3.0003V17H1.99852V3.0003H0L3.00029 0L6.00058 3.0003H3.99704Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_235_13315)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_235_13315",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -266,
    y: -28,
    width: 410,
    height: 266
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.013 -27.0029H-265.027V237.023H143.013V-27.0029Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_235_13315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49503 -2.5H-2.50439V19.5038H8.49503V-2.5Z",
    fill: "#3F3065"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_235_13315",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 14,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99707 12.0012V10.0027H13.9994V12.0012H6.99707ZM6.99707 17V15.0015H10.9991V17H6.99707ZM6.99707 6.99735V4.99882H16.9997V6.99735H6.99707ZM6.99707 1.99853V0H20V1.99853H6.99707Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_235_13315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4993 -2.50098H4.49756V19.5029H22.4993V-2.50098Z",
    fill: "#3F3065"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalisis);
export default __webpack_public_path__ + "static/media/icon-analisis.45ab9e0fac665da58f0db3cc96b0db95.svg";
export { ForwardRef as ReactComponent };